<template>
  <div>
    <button class="file-type-button" :class="{ 'file-type-button--inactive': !isActive }" @click="onClickFileTypeButton(fileType)">
      <slot />
    </button>
  </div>
</template>

<script setup lang="ts">
import { ImportFileType } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { useUnmanagedBusinessStore } from '../pages/unmanagedBusinessStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const props = defineProps<{
  fileType: ImportFileType;
}>();

const store = useUnmanagedBusinessStore();
const { changeSelectedFileType, fetchUnmanagedBusinesses } = store;
const { state } = storeToRefs(store);

const isActive = computed(() => state.value.selectedFileType === props.fileType);

/**
 * ファイルタイプボタンをクリックした時の処理
 * @param fileType - ファイルタイプ
 */
const onClickFileTypeButton = async (fileType: ImportFileType) => {
  changeSelectedFileType(props.fileType);
  await fetchUnmanagedBusinesses();
};
</script>

<style lang="scss" scoped>
.file-type-button {
  background-color: $semanticWhite;
  border: 1px solid $borderActive;
  border-radius: 90px;
  padding: 4px 8px;
  text-align: center;
  min-width: 80px;

  font-family: Noto Sans JP;
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  color: $semanticPrimary;

  &--inactive {
    opacity: 40%;
  }
}
</style>
